import { ButtonInfo } from "../items";

// 依頼受付用権限情報model
export class ReceptionPermissions {

  // 編集
  public edit: ButtonInfo;

  // 削除
  public delete: ButtonInfo;

  // コピー
  public copy: ButtonInfo;

  // 引用
  public quote: ButtonInfo;

}
